import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useCreateSpotifyOAuthToken } from "../api-generated";
import CenteredLoading from "./CenteredLoading";
import { SPOTIFY_TOP_TRACKS_ROUTE } from "../routes";
import ErrorLoading from "./ErrorLoading";

const SpotifyRedirect: React.FC = () => {
  //const searchParams = useSearchParams();
  const createSpotifyOAuthTokenMutation = useCreateSpotifyOAuthToken();

  const location = useLocation();
  useEffect(() => {
    console.log(
      "SpotifyRedirect mounted! query be:",
      createSpotifyOAuthTokenMutation
    );
  }, []);

  useEffect(() => {
    console.log("holalaaaa in SpitfyRedirect useEffect");
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    //TODO: check error
    //const error = searchParams.get("error");

    if (createSpotifyOAuthTokenMutation.isLoading) {
      console.log("already creating token!");
      return;
    }

    console.log("is not loading...");
    if (code && state) {
      console.log("mutating!");
      createSpotifyOAuthTokenMutation.mutate({ data: { code, state } });
    }
  }, [location.search, createSpotifyOAuthTokenMutation.isLoading]);

  if (createSpotifyOAuthTokenMutation.isSuccess) {
    return <Navigate to={SPOTIFY_TOP_TRACKS_ROUTE} />;
  }

  if (createSpotifyOAuthTokenMutation.isError) {
    return <ErrorLoading error={createSpotifyOAuthTokenMutation.error} />;
  }

  return <CenteredLoading />;
};

export default SpotifyRedirect;
